export type DashTab = 'home' | 'today' | 'operations' | 'callhistory' | 'assistant' | 'department' | 'team'

export const BASE_TABS: DashTab[] = ['home', 'today', 'operations', 'callhistory', 'assistant']

export function visibleDashboardTabs(opts: { isAdmin: boolean; headsDept: boolean }): DashTab[] {
  return [
    ...BASE_TABS,
    ...((opts.headsDept || opts.isAdmin) ? (['department'] as DashTab[]) : []),
    ...(opts.isAdmin ? (['team'] as DashTab[]) : []),
  ]
}
